<app-loader *ngIf="isDisabled"></app-loader>
{{this.Filter.FinancialMsg}}
<div class="card" style="min-height: 100%;">
    <div class="card-body p-1">
        <div class="row g-3">
            <div class="col-md"
                *ngIf="(this.common.ToLowerCase(this.Filter.Type) == 'd' ||this.common.ToLowerCase(this.Filter.Type) == 'i'||this.common.ToLowerCase(this.Filter.Type) == 'ad'||this.common.ToLowerCase(this.Filter.Type) == 'ai') || !this.Filter.IsNewRegime">
                <div class="Stick-Header">
                    <div style="height: 6rem;"
                        (click)="(this.common.ToLowerCase(this.Filter.Type) == 'd' ||this.common.ToLowerCase(this.Filter.Type) == 'i'||this.common.ToLowerCase(this.Filter.Type) == 'ad'||this.common.ToLowerCase(this.Filter.Type) == 'ai')?this.Filter.IsNewRegime = !this.Filter.IsNewRegime:null">
                        <div class="row py-2"
                            style="background: lightgray;width: 18rem;justify-self: center;border-radius: 9px;"
                            [ngClass]="{ 'hightlight-regime':!this.Filter.IsNewRegime}">
                            <div class="col-4 align-self-center">
                                <i class="bi bi-check2-circle" style="font-size: x-large;"
                                    [ngStyle]="{ 'color':!this.Filter.IsNewRegime?'var(--primary)':''}"></i>
                            </div>
                            <div class="col-8">
                                <h5>Old Tax Regime</h5>
                                <h6 style="font-weight: 600;"><i class="bi bi-currency-rupee"></i>{{this.Total.old}}
                                </h6>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-8">
                            <span style="font-weight: 500;color:gray">Particulars</span>
                        </div>
                        <div class="col-4 text-end">
                            <span style="font-weight: 500;color:gray">Declared Amount</span>
                        </div>
                    </div>
                    <hr />
                </div>
                <div>
                    <div class="row g-0">
                        <div class="col-12 mb-4">
                            <h5 class="m-0">Earnings</h5>
                        </div>
                        <div class="row g-0 ps-2 mb-2" *ngFor="let regimeData of RegimeDatasE; let i = index">
                            <div class="col-9">
                                <span [ngStyle]="{ 'font-weight':regimeData.IsTotal?600:400}">
                                    <!-- <i class="bi bi-plus-circle-fill"
                                        [ngStyle]="{'color': regimeData.IsDetailOld ? 'var(--success)':'var(--placeholder)'}"
                                        *ngIf="!regimeData.IsTotal"
                                        (click)="regimeData.IsDetailOld?Details(regimeData.SrNo,false):null"></i> -->
                                    {{regimeData.Items}}
                                </span>
                            </div>
                            <div class="col-3 text-end">
                                <span [ngStyle]="{ 'font-weight':regimeData.IsTotal?600:400}"><i
                                        class="bi bi-currency-rupee"></i>{{regimeData.OldExemption}}
                                </span>
                            </div>
                        </div>
                        <hr />
                        <!-- <div class="row g-0 ps-2 mb-2">
                    <div class="col-8">
                        <h6 style="font-weight: 600;">Gross Total Income</h6>
                    </div>
                    <div class="col-4 text-end">
                        <h6 style="font-weight: 700;"><i class="bi bi-currency-rupee"></i>{{this.RegimeDatasE.old}}</h6>
                    </div>
                </div>
                <hr /> -->
                    </div>

                    <div class="row g-0 mt-4">
                        <div class="col-12 mb-4">
                            <h5 class="m-0">Exemption Based on your {{(this.Filter.Type == 'i' || this.Filter.Type
                                == 'id'?'Proof Submission':'Declaration')}} </h5>
                        </div>
                        <div class="row g-0 ps-2 mb-2" *ngFor="let regimeData of RegimeDatasD; let i = index">
                            <div class="col-9">
                                <span [ngStyle]="{ 'font-weight':regimeData.IsTotal?600:400}">
                                    <!-- <i class="bi bi-plus-circle-fill"
                                        [ngStyle]="{'color': regimeData.IsDetailOld ?'var(--success)':'var(--placeholder)'}"
                                        *ngIf="!regimeData.IsTotal"
                                        (click)="regimeData.IsDetailOld?Details(regimeData.SrNo,false):null"></i> -->
                                    {{regimeData.Items}}
                                </span>
                            </div>
                            <div class="col-3 text-end">
                                <span [ngStyle]="{ 'font-weight':regimeData.IsTotal?600:400}"><i
                                        class="bi bi-currency-rupee"></i>{{regimeData.OldExemption}}
                                </span>
                            </div>
                        </div>
                        <hr />
                        <!-- <div class="row g-0 ps-2 mb-2">
                    <div class="col-8">
                        <h6 style="font-weight: 600;">Total Exemption</h6>
                    </div>
                    <div class="col-4 text-end">
                        <h6 style="font-weight: 700;"><i class="bi bi-currency-rupee"></i>{{this.RegimeDatasD.old}}</h6>
                    </div>
                </div>
                <hr /> -->
                    </div>
                </div>
            </div>
            <div class="col-md"
                *ngIf="(this.common.ToLowerCase(this.Filter.Type) == 'd' ||this.common.ToLowerCase(this.Filter.Type) == 'i'||this.common.ToLowerCase(this.Filter.Type) == 'ad'||this.common.ToLowerCase(this.Filter.Type) == 'ai') || this.Filter.IsNewRegime">
                <div class="Stick-Header">
                    <div style="height: 6rem;"
                        (click)="(this.common.ToLowerCase(this.Filter.Type) == 'd' ||this.common.ToLowerCase(this.Filter.Type) == 'i'||this.common.ToLowerCase(this.Filter.Type) == 'ad'||this.common.ToLowerCase(this.Filter.Type) == 'ai')?this.Filter.IsNewRegime = !this.Filter.IsNewRegime:null">
                        <div class="row py-2"
                            style="background: lightgray;width: 18rem;justify-self: center;border-radius: 9px;"
                            [ngClass]="{ 'hightlight-regime':this.Filter.IsNewRegime}">
                            <div class="col-4 align-self-center">
                                <i class="bi bi-check2-circle" style="font-size: x-large;"
                                    [ngStyle]="{ 'color':this.Filter.IsNewRegime?'var(--primary)':''}"></i>
                            </div>
                            <div class="col-8">
                                <h5>New Tax Regime</h5>
                                <h6 style="font-weight: 600;"><i class="bi bi-currency-rupee"></i>{{this.Total.new}}
                                </h6>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-8">
                            <span style="font-weight: 500;color:gray">Particulars</span>
                        </div>
                        <div class="col-4 text-end">
                            <span style="font-weight: 500;color:gray">Declared Amount</span>
                        </div>
                    </div>
                    <hr />
                </div>
                <div>
                    <div class="row g-0">
                        <div class="col-12 mb-4">
                            <h5 class="m-0">Earnings</h5>
                        </div>
                        <div class="row g-0 ps-2 mb-2" *ngFor="let regimeData of RegimeDatasE; let i = index">
                            <div class="col-9">
                                <span [ngStyle]="{ 'font-weight':regimeData.IsTotal?600:400}">
                                    <!-- <i class="bi bi-plus-circle-fill"
                                        [ngStyle]="{'color': regimeData.IsDetailNew ? 'var(--success)':'var(--placeholder)'}"
                                        *ngIf="!regimeData.IsTotal"
                                        (click)="regimeData.IsDetailNew?Details(regimeData.SrNo,true):null"></i> -->
                                    {{regimeData.Items}}
                                </span>
                            </div>
                            <div class="col-3 text-end">
                                <span [ngStyle]="{ 'font-weight':regimeData.IsTotal?600:400}"><i
                                        class="bi bi-currency-rupee"></i>{{regimeData.NewExemption}}
                                </span>
                            </div>
                        </div>
                        <hr />
                        <!-- <div class="row g-0 ps-2 mb-2">
                    <div class="col-8">
                        <h6 style="font-weight: 600;">Gross Total Income</h6>
                    </div>
                    <div class="col-4 text-end">
                        <h6 style="font-weight: 700;"><i class="bi bi-currency-rupee"></i>{{this.RegimeDatasE.new}}</h6>
                    </div>
                </div>
                <hr /> -->
                    </div>

                    <div class="row g-0 mt-4">
                        <div class="col-12 mb-4">
                            <h5 class="m-0">Exemption Based on your {{(this.Filter.Type == 'i' || this.Filter.Type ==
                                'id'?'Proof Submission':'Declaration')}} </h5>
                        </div>
                        <div class="row g-0 ps-2 mb-2" *ngFor="let regimeData of RegimeDatasD; let i = index">
                            <div class="col-9">
                                <span [ngStyle]="{ 'font-weight':regimeData.IsTotal?600:400}">
                                    <!-- <i class="bi bi-plus-circle-fill"
                                        [ngStyle]="{'color': regimeData.IsDetailNew ? 'var(--success)':'var(--placeholder)'}"
                                        *ngIf="!regimeData.IsTotal"
                                        (click)="regimeData.IsDetailNew?Details(regimeData.SrNo,true):null"></i> -->
                                    {{regimeData.Items}}
                                </span>
                            </div>
                            <div class="col-3 text-end">
                                <span [ngStyle]="{ 'font-weight':regimeData.IsTotal?600:400}"><i
                                        class="bi bi-currency-rupee"></i>{{regimeData.NewExemption}}
                                </span>
                            </div>
                        </div>
                        <hr />
                        <!-- <div class="row g-0 ps-2 mb-2">
                    <div class="col-8">
                        <h6 style="font-weight: 600;">Total Exemption</h6>
                    </div>
                    <div class="col-4 text-end">
                        <h6 style="font-weight: 700;"><i class="bi bi-currency-rupee"></i>{{this.RegimeDatasD.new}}</h6>
                    </div>
                </div>
                <hr /> -->
                    </div>
                </div>

            </div>
        </div>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col"></div>
            <div class="col-auto">
                <button type="button" class="btn btn-outline-primary mx-1" [disabled]="isDisabled" (click)="Cancel()"><i
                        class="bi bi-arrow-left" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Cancel':'Loading...'}}</button>

                <button type="button" class="btn btn-success mx-1" [disabled]="isDisabled"
                    *ngIf="this.Filter.IsDraft && this.common.PageRight.IsEdit" (click)="finalSave()"><i
                        class="bi bi-bookmark-check" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Final Submit':'Loading...'}}</button>

                <!-- <button type="button" class="btn btn-success mx-1" [disabled]="isDisabled"
                    *ngIf="!this.Filter.IsDraft && this.common.PageRight.IsEdit && this.user.UserType == 'A'"
                    (click)="ESS_IncomeTaxSummaryDetails_InsertUpdate()"><i class="bi bi-bookmark-check"
                        *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Save Tax':'Loading...'}}</button> -->
            </div>
        </div>
    </div>
</div>